import React, { useState } from 'react';
import Testimonial02 from '../../../assets/image/testimonial/testimonial-2.jpg';
import Testimonial03 from '../../../assets/image/testimonial/testimonial-3.jpg';
import Testimonial04 from '../../../assets/image/testimonial/testimonial-4.jpg';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Thumbs, FreeMode, Pagination } from "swiper";

function Testimonial() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      <section className="testimonial-section testimonial-box-one">
        <div className="container">
          <div className="testimonial-name">What Our Community Says</div>

          <div className="testimonial-slider">
            <Swiper
              className="swiper testimonial-reviews"
              spaceBetween={60}
              slidesPerView={1}
              loop={true}
              thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
              pagination={{
                clickable: true,
                el: ".swiper-pagination",
              }}
              speed={500}
              modules={[Autoplay, Navigation, Thumbs, FreeMode, Pagination]}
            >
              <div className="swiper-wrapper">
                <SwiperSlide className="swiper-slide">
                  <div className="testimonial-content">
                    <div className="testimonial-ratings">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                    </div>

                    <div className="testimonial-text">
                      "The State of GTS has been a game-changer for our community. Their innovative programs and resources have truly empowered us to tackle challenges and thrive. The team's dedication to our well-being is unmatched."
                    </div>

                    <div className="testimonial-thumb-card">
                      <h5>Martin McLaughlin</h5>
                      <span>Community Leader</span>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide className="swiper-slide">
                  <div className="testimonial-content">
                    <div className="testimonial-ratings">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                    </div>

                    <div className="testimonial-text">
                      "The services provided by the State of GTS have made a significant impact on my family. From housing support to job resources, they’ve truly made a difference in our lives. Thank you for putting the community first!"
                    </div>

                    <div className="testimonial-thumb-card">
                      <h5>Aleesha Brown</h5>
                      <span>Resident</span>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide className="swiper-slide">
                  <div className="testimonial-content">
                    <div className="testimonial-ratings">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                    </div>

                    <div className="testimonial-text">
                      "I am incredibly grateful for the support I’ve received from the State of GTS. Their public health initiatives and community engagement programs have made our city a better place to live."
                    </div>

                    <div className="testimonial-thumb-card">
                      <h5>Kevin Martin</h5>
                      <span>Program Beneficiary</span>
                    </div>
                  </div>
                </SwiperSlide>
              </div>

              <div className="swiper-pagination" />
            </Swiper>

            <Swiper
              className="testimonial-thumb"
              slidesPerView={3}
              spaceBetween={0}
              modules={[FreeMode, Navigation, Thumbs]}
              onSwiper={setThumbsSwiper}
              freeMode={true}
              watchSlidesProgress={true}
            >
              <div className="swiper-wrapper">
                <SwiperSlide className="swiper-slide">
                  <img src={Testimonial02} className="img-fluid" alt="Martin McLaughlin" />
                  <i className="fa-solid fa-quote-left" />
                </SwiperSlide>

                <SwiperSlide className="swiper-slide">
                  <img src={Testimonial03} className="img-fluid" alt="Aleesha Brown" />
                  <i className="fa-solid fa-quote-left" />
                </SwiperSlide>

                <SwiperSlide className="swiper-slide">
                  <img src={Testimonial04} className="img-fluid" alt="Kevin Martin" />
                  <i className="fa-solid fa-quote-left" />
                </SwiperSlide>
              </div>
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonial;
